export class Rectangle {

  public x: number;
  public y: number;
  public width: number;
  public height: number;

  constructor(x: number = 0, y: number = 0, width: number = 0, height: number = 0) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }

  get left(): number {
    return (this.x);
  }
  set left(value: number) {
    this.width = (this.width + (this.x - value));
    this.x = value;
  }
  get right(): number {
    return ((this.x + this.width));
  }
  set right(value: number) {
    this.width = (value - this.x);
  }
  get top(): number {
    return (this.y);
  }
  set top(value: number) {
    this.height = (this.height + (this.y - value));
    this.y = value;
  }
  get bottom(): number {
    return ((this.y + this.height));
  }
  set bottom(value: number) {
    this.height = (value - this.y);
  }
  
  public clone(): Rectangle {
    return (new Rectangle(this.x, this.y, this.width, this.height));
  }
  public isEmpty(): Boolean {
    return ((((this.width <= 0)) || ((this.height <= 0))));
  }
  public setEmpty() {
    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;
  }
  public inflate(dx: number, dy: number): void {
    this.x = (this.x - dx);
    this.width = (this.width + (2 * dx));
    this.y = (this.y - dy);
    this.height = (this.height + (2 * dy));
  }
  public offset(dx: number, dy: number): void {
    this.x = (this.x + dx);
    this.y = (this.y + dy);
  }
  public contains(x: number, y: number): boolean {
    return ((((((((x >= this.x)) && ((x < (this.x + this.width))))) && ((y >= this.y)))) && ((y < (this.y + this.height)))));
  }
  public containsRect(rect: Rectangle): boolean {
    var r1: number = (rect.x + rect.width);
    var b1: number = (rect.y + rect.height);
    var r2: number = (this.x + this.width);
    var b2: number = (this.y + this.height);
    return ((((((((((((((((rect.x >= this.x)) && ((rect.x < r2)))) && ((rect.y >= this.y)))) && ((rect.y < b2)))) && ((r1 > this.x)))) && ((r1 <= r2)))) && ((b1 > this.y)))) && ((b1 <= b2))));
  }
  public intersection(toIntersect: Rectangle): Rectangle {
    var result: Rectangle = new Rectangle();
    if (((this.isEmpty()) || (toIntersect.isEmpty()))) {
      result.setEmpty();
      return (result);
    };
    result.x = Math.max(this.x, toIntersect.x);
    result.y = Math.max(this.y, toIntersect.y);
    result.width = (Math.min((this.x + this.width), (toIntersect.x + toIntersect.width)) - result.x);
    result.height = (Math.min((this.y + this.height), (toIntersect.y + toIntersect.height)) - result.y);
    if ((((result.width <= 0)) || ((result.height <= 0)))) {
      result.setEmpty();
    };
    return (result);
  }
  public intersects(toIntersect: Rectangle): Boolean {
    if (((this.isEmpty()) || (toIntersect.isEmpty()))) {
      return (false);
    };
    var resultx: number = Math.max(this.x, toIntersect.x);
    var resulty: number = Math.max(this.y, toIntersect.y);
    var resultwidth: number = (Math.min((this.x + this.width), (toIntersect.x + toIntersect.width)) - resultx);
    var resultheight: number = (Math.min((this.y + this.height), (toIntersect.y + toIntersect.height)) - resulty);
    if ((((resultwidth <= 0)) || ((resultheight <= 0)))) {
      return (false);
    };
    return (true);
  }
  public union(toUnion: Rectangle): Rectangle {
    var r: Rectangle;
    if (this.isEmpty()) {
      return (toUnion.clone());
    };
    if (toUnion.isEmpty()) {
      return (this.clone());
    };
    r = new Rectangle();
    r.x = Math.min(this.x, toUnion.x);
    r.y = Math.min(this.y, toUnion.y);
    r.width = (Math.max((this.x + this.width), (toUnion.x + toUnion.width)) - r.x);
    r.height = (Math.max((this.y + this.height), (toUnion.y + toUnion.height)) - r.y);
    return (r);
  }
  public equals(toCompare: Rectangle): Boolean {
    return ((((((((toCompare.x == this.x)) && ((toCompare.y == this.y)))) && ((toCompare.width == this.width)))) && ((toCompare.height == this.height))));
  }
}
